import isWithinInterval from 'date-fns/isWithinInterval';
import isSameDay from 'date-fns/isSameDay';
import { ensureArray } from './utils';
import { minTime, maxTime } from './constants';

/**
 *
 * @param date
 * @param value
 * @returns {boolean}
 */
function testDate(date, value) {
	if (!(value instanceof Date)) {
		return false;
	}

	return isSameDay(date, value);
}

/**
 *
 * @param date
 * @param value
 * @returns {*}
 */
function testFunction(date, value) {
	if (typeof value !== 'function') {
		return;
	}

	return value(date);
}

export function isStartDate(date, value) {
	if (value === undefined || !('from' in value)) {
		return false;
	}

	return testDate(date, value.from);
}

export function isEndDate(date, value) {
	if (value === undefined || !('to' in value)) {
		return false;
	}

	return testDate(date, value.to);
}

/**
 *
 * @param date
 * @param value
 * @returns {boolean}
 */
export function testRange(date, value) {
	if (value === undefined || (!('from' in value) && !('to' in value))) {
		return false;
	}

	let after = true;
	let before = true;

	if (value.from !== undefined) {
		after = isWithinInterval(date, { start: value.from, end: maxTime });
	}

	if (value.to !== undefined) {
		before = isWithinInterval(date, { start: minTime, end: value.to });
	}

	return (before && after);
}

export function testArray(date, dirtyDates, test) {
	let dates;

	if (Array.isArray(dirtyDates)) {
		dates = dirtyDates;
	} else {
		dates = [ dirtyDates ];
	}

	return dates.some(value => test(date, value));
}

/**
 *
 * @param date The date to test against.
 * @param dates The dates to test.
 * @returns {boolean}
 */
export function test(date, dates) {
	let tests = ensureArray(dates);

	let matches = tests.some(value => {
		return (
			testDate(date, value) ||
            testRange(date, value) ||
            testFunction(date, value)
		);
	});

	return {
		matches: matches,
		end: tests.some(value => isEndDate(date, value)),
		start: tests.some(value => isStartDate(date, value)),
	};
}
